// extracted by mini-css-extract-plugin
export var projectSlider = "ProjectSlider-module--projectSlider--qsFw5";
export var projectItem = "ProjectSlider-module--projectItem--3GhOz";